import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateSettingValue = async (id, value) => {
  // The backend `value` column is always a string, but numeric settings run
  // through a Yup schema that casts to a JS number - stringify it back here
  // so the request body always matches the column type.
  return axios.patch(`/api/settings/${id}`, JSON.stringify({ value: String(value) }));
};

export const useUpdateSettingValue = (id) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (value) => updateSettingValue(id, value),
    onSuccess: () => {
      enqueueSnackbar('Setting was successfully updated', { variant: 'success' });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
